import { APPS2_SUCCESS } from 'app/actions/apps/apps';
// import { APP_SUBSCRIBE_SUCCESS } from 'app/actions/apps/subscribe';


const defaultState = {
  // данные тарифов
  // [id]: {}
  // ...
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case APPS2_SUCCESS: {
      return { ...action.payload.tariffs };
    }
    // case APP_SUBSCRIBE_SUCCESS: {
    //   return { ...state, ...action.payload.tariffs };
    // }
    default:
  }

  return state;
}
